import React from 'react';

export function capitalize(text){
    if(text){
        const lowerText = text.toLowerCase();
        return lowerText.charAt(0).toUpperCase() + lowerText.slice(1);
    }
}
function Alert(props) {
  return (
    <div style={{height:"7vh"}}>
      {/* style should be wrapped in a object */}
    {props.alert && //if alert is not null
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" className="d-none">
        <symbol id="check-circle-fill" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </symbol>
        <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </symbol>
      </svg>

      <div className={`alert alert-${props.alert.type} d-flex align-items-center`} role="alert">
        <svg className="bi flex-shrink-0 me-2" role="img" aria-label={props.alert.type} width="24" height="24">
          <use href={props.alert.type === 'success' ? "#check-circle-fill" : "#exclamation-triangle-fill"} />
        </svg>
        <div>
        <strong>{capitalize(props.alert.type==='danger'?'error':props.alert.type)}</strong> : {props.alert.msg}
        </div>
      </div>
    </div>}
  </div>
  );
}

export default Alert;